import dayjs from 'dayjs';

export const dateToLocaleString = (date: string, locale: string, formatConfig?: string) => {
  const dateFormat = (locale === 'it' ? 'DD/MM/YYYY' : 'YYYY/MM/DD').concat(formatConfig ? ` ${formatConfig}` : '');
  
  return dayjs(date).format(dateFormat);
};